export const ANALYTICS_PATH = "/ufhIqz8QTOtp2eEI";
